import { Product } from "./shop.product.model";

/**
 * Class for representing an item in the shopping cart
 */
export class ShopCartItem {
    /**
     * constructor
     * @param product
     * @param count
     * @param categories
     * @param freePrice
     * @param text
     * @param forceCountModifiable
     * @param uuid
     */
    constructor(product: Product, count: number, categories: string[], freePrice: number = null, text: string = null, forceCountModifiable: boolean = false) {
        this.product = product;
        this.count = count;
        this.categories = categories
        this.freePrice = freePrice;
        this.text = text
        this.forceCountModifiable = forceCountModifiable;
        this.uuid = this.generateUUID();
    }

    /**
     * returns the price for the cart item
     */
    getPrice(): number {
        const price = this.freePrice != null ? this.freePrice : this.product.price;
        return price ? price : 0;
    }

    /**
     * Holding the product
     */
    product: Product;

    /**
     * Holds a free price selection, if this is possible.
     */
    public freePrice: number;

    /**
     * Force the count to be modifiable by the user.
     */
    public forceCountModifiable: boolean = false;

    /**
     * count of this product
     */
    count: number;

    /**
     * individual text, given by the user
     */
    text: string;

    /**
     * List of categories
     */
    categories: string[]

    /**
     * if the product is send as gift, add the name of the sender
     */
    giftSender: string;

    /**
     * if the product is send as gift, add the name of the receiver
     */
    giftReceiver: string;

    /**
     * if the product is send as gift, add a message
     */
    giftMessage: string;

    /**
     * uuid of the item
     */
    uuid: string;

    /**
     * generates a uuid
     */
    private generateUUID(): string {
        return this.product.id + '_' + this.getPrice() + '_' + this.text;
    }

    /**
     * generates a uuid static
     */
    static generateUUID(product: Product, freePrice: number, text: string): string {
        const price = freePrice != null ? freePrice : product.price;
        return product.id + '_' + price + '_' + text;
    }
}
